import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "w-full pt-[24px] px-[32px] max-h-[450px] overflow-y-auto" }
const _hoisted_3 = { class: "pb-2 text-xl leading-8 tracking-[0.01rem] font-semibold text-primary-text-color" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "mb-2" }
const _hoisted_6 = { class: "mb-2" }
const _hoisted_7 = { class: "mb-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "w-full flex items-center justify-between pt-3 mt-[24px] border-t border-black/15" }

import QuestionnaireSelectMenu from "../parts/QuestionnaireSelectMenu.vue";
import QuestionnaireTextArea from "../parts/QuestionnaireTextArea.vue";
import QuestionnaireTextField from "../parts/QuestionnaireTextField.vue";
import QuestionnaireButtonPrev from "../parts/QuestionnaireButtonPrev.vue";
import QuestionnaireButtonNext from "../parts/QuestionnaireButtonNext.vue";
import { reactive } from "vue";

type Props = {
  title: string;
  textAreaTitleOne: string;
  textAreaPlaceholderOne: string;
  textAreaTitleTwo: string;
  textAreaPlaceholderTwo: string;
  textAreaTitleThree: string;
  textAreaPlaceholderThree: string;
  textAreaTitleFour: string;
  textAreaPlaceholderFour: string;
  selectMenuDataOne: any;
  selectMenuDataOneTitle: string;
  textFieldOneText: string;
  textFieldOneRequired: boolean;
  textFieldOnePlaceholder: string;
  prevButtonText: string;
  nextButtonText: string;
  data?: {
    description?: string;
    whatToSchedule?: string;
    days?: string;
    missingMaterial?: string;
    dispoNotes?: string;
    fieldInstruction?: string;
  };
};

type Emits = {
  (event: "onStepBack"): void;
  (
    event: "onSubmit",
    payload: {
      description: string;
      whatToSchedule: string;
      days: string;
      missingMaterial: string;
      dispoNotes: string;
      fieldInstruction: string;
    }
  ): void;
};
interface ErrorField {
  value: string;
  isError: boolean;
}

type ErrorsState = Record<string, ErrorField>;


export default /*@__PURE__*/_defineComponent({
  __name: 'AbnahmeAppointmentNotCompleted',
  props: {
    title: {},
    textAreaTitleOne: {},
    textAreaPlaceholderOne: {},
    textAreaTitleTwo: {},
    textAreaPlaceholderTwo: {},
    textAreaTitleThree: {},
    textAreaPlaceholderThree: {},
    textAreaTitleFour: {},
    textAreaPlaceholderFour: {},
    selectMenuDataOne: {},
    selectMenuDataOneTitle: {},
    textFieldOneText: {},
    textFieldOneRequired: { type: Boolean },
    textFieldOnePlaceholder: {},
    prevButtonText: {},
    nextButtonText: {},
    data: {}
  },
  emits: ["onStepBack", "onSubmit"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit;

const props = __props;

const state = reactive({
  writeWhatHappened:
    props.data && props.data.description ? props.data.description : "",
  whatDoWeSchedule:
    props.data && props.data.whatToSchedule ? props.data.whatToSchedule : "",
  howManyDays: props.data && props.data.days ? props.data.days : "",
  whatMaterialIsMissing:
    props.data && props.data.missingMaterial ? props.data.missingMaterial : "",
  dispoNotes: props.data && props.data.dispoNotes ? props.data.dispoNotes : "",
  whatNeedsToBeDone:
    props.data && props.data.fieldInstruction
      ? props.data.fieldInstruction
      : "",
});

const errors = reactive<ErrorsState>({
  writeWhatHappened: {
    value: "",
    isError: false,
  },
  whatDoWeSchedule: {
    value: "",
    isError: false,
  },
  howManyDays: {
    value: "",
    isError: false,
  },
  whatMaterialIsMissing: {
    value: "",
    isError: false,
  },
  dispoNotes: {
    value: "",
    isError: false,
  },
  whatNeedsToBeDone: {
    value: "",
    isError: false,
  },
});

const validate = () => {
  if (state.writeWhatHappened) {
    if (state.writeWhatHappened.trim().length > 255) {
      errors.writeWhatHappened.value = "Maximum number of characters is 255.";
      errors.writeWhatHappened.isError = true;
    } else {
      errors.writeWhatHappened.value = "";
      errors.writeWhatHappened.isError = false;
    }
  } else {
    errors.writeWhatHappened.value = "This field is required.";
    errors.writeWhatHappened.isError = true;
  }

  if (state.whatDoWeSchedule) {
    if (state.whatDoWeSchedule.trim().length > 255) {
      errors.whatDoWeSchedule.value = "Maximum number of characters is 255.";
      errors.whatDoWeSchedule.isError = true;
    } else {
      errors.whatDoWeSchedule.value = "";
      errors.whatDoWeSchedule.isError = false;
    }
  } else {
    errors.whatDoWeSchedule.value = "This field is required.";
    errors.whatDoWeSchedule.isError = true;
  }

  if (state.whatMaterialIsMissing) {
    if (state.whatMaterialIsMissing.trim().length > 255) {
      errors.whatMaterialIsMissing.value =
        "Maximum number of characters is 255.";
      errors.whatMaterialIsMissing.isError = true;
    } else {
      errors.whatMaterialIsMissing.value = "";
      errors.whatMaterialIsMissing.isError = false;
    }
  }

  if (state.dispoNotes) {
    if (state.dispoNotes.trim().length > 255) {
      errors.dispoNotes.value = "Maximum number of characters is 255.";
      errors.dispoNotes.isError = true;
    } else {
      errors.dispoNotes.value = "";
      errors.dispoNotes.isError = false;
    }
  }

  if (state.whatNeedsToBeDone) {
    if (state.whatNeedsToBeDone.trim().length > 255) {
      errors.whatNeedsToBeDone.value = "Maximum number of characters is 255.";
      errors.whatNeedsToBeDone.isError = true;
    } else {
      errors.whatNeedsToBeDone.value = "";
      errors.whatNeedsToBeDone.isError = false;
    }
  } else {
    errors.whatNeedsToBeDone.value = "This field is required.";
    errors.whatNeedsToBeDone.isError = true;
  }

  let keys = Object.keys(errors);
  let invalidFields = keys.filter((item: string) => errors[item].isError);
  return invalidFields.length === 0;
};

const onSuccess = () => {
  state.writeWhatHappened = "";
  state.whatDoWeSchedule = "";
  state.howManyDays = "";
  state.whatMaterialIsMissing = "";
  state.dispoNotes = "";
  state.whatNeedsToBeDone = "";
};

const onSubmit = () => {
  if (!validate()) return;

  const data = {
    description: state.writeWhatHappened,
    whatToSchedule: state.whatDoWeSchedule,
    days: state.howManyDays,
    missingMaterial: state.whatMaterialIsMissing,
    dispoNotes: state.dispoNotes,
    fieldInstruction: state.whatNeedsToBeDone,
  };

  emits("onSubmit", data);
  onSuccess();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(QuestionnaireTextArea, {
            modelValue: state.writeWhatHappened,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.writeWhatHappened) = $event)),
            title: __props.textAreaTitleOne,
            placeholder: __props.textAreaPlaceholderOne,
            "is-error": errors.writeWhatHappened.isError,
            "error-message": errors.writeWhatHappened.value
          }, null, 8, ["modelValue", "title", "placeholder", "is-error", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(QuestionnaireSelectMenu, {
            modelValue: state.whatDoWeSchedule,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.whatDoWeSchedule) = $event)),
            title: __props.selectMenuDataOneTitle,
            options: __props.selectMenuDataOne,
            "is-error": errors.whatDoWeSchedule.isError,
            "error-message": errors.whatDoWeSchedule.value
          }, null, 8, ["modelValue", "title", "options", "is-error", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(QuestionnaireTextField, {
            modelValue: state.howManyDays,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.howManyDays) = $event)),
            title: __props.textFieldOneText,
            "is-required": __props.textFieldOneRequired,
            placeholder: __props.textFieldOnePlaceholder,
            "is-error": errors.howManyDays.isError,
            "error-message": errors.howManyDays.value
          }, null, 8, ["modelValue", "title", "is-required", "placeholder", "is-error", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(QuestionnaireTextArea, {
            modelValue: state.whatMaterialIsMissing,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.whatMaterialIsMissing) = $event)),
            title: __props.textAreaTitleTwo,
            placeholder: __props.textAreaPlaceholderTwo,
            "is-error": errors.whatMaterialIsMissing.isError,
            "error-message": errors.whatMaterialIsMissing.value
          }, null, 8, ["modelValue", "title", "placeholder", "is-error", "error-message"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(QuestionnaireTextArea, {
            modelValue: state.dispoNotes,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.dispoNotes) = $event)),
            title: __props.textAreaTitleThree,
            placeholder: __props.textAreaPlaceholderThree,
            "is-error": errors.dispoNotes.isError,
            "error-message": errors.dispoNotes.value
          }, null, 8, ["modelValue", "title", "placeholder", "is-error", "error-message"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(QuestionnaireTextArea, {
            modelValue: state.whatNeedsToBeDone,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.whatNeedsToBeDone) = $event)),
            title: __props.textAreaTitleFour,
            placeholder: __props.textAreaPlaceholderFour,
            "is-error": errors.whatNeedsToBeDone.isError,
            "error-message": errors.whatNeedsToBeDone.value
          }, null, 8, ["modelValue", "title", "placeholder", "is-error", "error-message"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", null, [
        _createVNode(QuestionnaireButtonPrev, {
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('onStepBack'))),
          "button-text": __props.prevButtonText
        }, null, 8, ["button-text"])
      ]),
      _createElementVNode("div", { onClick: onSubmit }, [
        _createVNode(QuestionnaireButtonNext, {
          "is-loading": false,
          "button-text": __props.nextButtonText
        }, null, 8, ["button-text"])
      ])
    ])
  ]))
}
}

})